//import RegulationPopup from './es6/Facility/Indicators/RegulationPopup';


function searchAndHighlight(searchTerm) {
    if (searchTerm !== '') {
        $('.highlighted').removeClass('highlighted');
        i = 1;
        tmp_uppercase = searchTerm.toUpperCase();
        tmp_lowercase = searchTerm.toLowerCase();
        $(".indicator_row").each(function() {
            if ($(this).text().indexOf(tmp_lowercase) != -1 || $(this).text().indexOf(tmp_uppercase) != -1) {
                $(this).children('.highlightable').addClass('highlighted');
            }
            i++;
        });
        if ($('.highlighted').length) {
            $(window).scrollTop($('.highlighted:first').position().top);
        } else {
            $('.search_msg').html('NO RESULTS');
        }
    }
}

function indicatorPopUpsHover() {
    $('.showRegPop').hover(function() {
        var that = $(this);
        $(that).next('.defPop').css('display', 'block').stop().animate({
            'opacity': 1
        }, 300);
        var ind_uid = $(this).attr('rel');
        var doneFunction = function(data, status, xhr){
        	if(data == 'FORBIDDEN'){
        		$(that).next('.defPop').addClass('popup_hidden');
        		var html = '<p style="font-size: 16px !important; text-align: center; font-weight: bold;">Thank you for your understanding</p>\
						    <p>&nbsp;</p>\
							<p style="text-align:center;"><strong>Indicator Views are limited for unregistered users.</strong></p><p style="text-align:center;"><strong>For unrestricted access to SNFQAPI.com please <a href="/register">register here.</a></strong></p>\
  							<p>&nbsp;</p>\
						    <p style="font-size: 12px !important; text-align: center; font-weight: normal;">INDICATORS are protected by copyright and are the property of SNFQAPI, LLC</p>';
        		$('.ind_content_' + ind_uid).html(html);
        	}else{
        		$('.ind_content_' + ind_uid).html(data);
        	}
        };
        apiAjaxCall('indicators/popup/'+ind_uid, 'GET', {}, {dataType: 'html'}, false, doneFunction);
    }, function() {
        $(this).next('.defPop').stop().animate({
            'opacity': 0
        }, $(this).next('.defPop').hasClass('popup_hidden') ? 1200 : 300, function() {
            $(this).css('display', 'none');
        });
    });
    $('.topRight, .indicator_desc_close').click(function() {
        $(this).parent().parent().stop().animate({
            'opacity': 0
        }, 300, function() {
            $(this).css('display', 'none');
        });
    });
}

function setupSurveyToggle(){
	$('.indHeaderMonthTable').click(function(e){
		if(e) e.preventDefault();
		$('.dash_division, .dash_cell_header').removeClass('tealBorder').removeClass('surveyMonth');
		var month = $(this).index() - 4,
			start_color_col = month + 5,
			end_color_col = start_color_col--;
			$('.division_' + start_color_col + ', .division_' + end_color_col).addClass('tealBorder');
			$('.dash_cell_header.division_' + end_color_col).addClass('surveyMonth');
		apiAjaxCall('dashboard/changeSurvey', 'POST', {survey_tracker: month}, {headers: {'Accept': 'application/json'}}, {403: 'Please contact your Committee Chairperson or Administrator to make changes to Dashboard.'});
	});
}

function canEdit(){
	if(!can_edit && !demo){
		popUpMsg('Please contact your Committee Chairperson or Administrator to make changes to the Dashboard.');
		return false;
	}
	return true;
}

function isMyView(){
	if(!is_user_view && !demo && !administrator && !ss_admin){
		popUpMsg('You can only modify the '+user_view+' Dashboard.');
		return false;
	}
	return true;
}

function set_db_reset(action) {
	var doneFunction = function(data, status, xhr){
		if(data == 'success'){
			if(view == 'ss'){
				window.location = '/facility/dashboard/' + dep + '?view=ss';
			}else{
				window.location = '/facility/dashboard/' + dep;
			}
		}
	}
	apiAjaxCall('tasks/reset', 'POST', {timeframe: action, dep: dep, view: view, daily: Boolean(is_daily)}, {}, {401: 'reset the dashboard.', 403: 'Please contact your Committee Chairperson or Administrator to make changes to dashboard.'}, doneFunction);
}

function assignUser(ind_uid, asn_user_val){
	if(!siteAdmin && !isMyView()){
		return false;
	}else if(!siteAdmin && !canEdit()){
		return false;
	}

	var task_uid = ($('.task_uid-' + ind_uid).val() == '' ? false : $('.task_uid-' + ind_uid).val());
	var data = {
		asned_usr_uid: asn_user_val,
		dep_uid: dep, //will be confirmed in case of modification
		reg_uid: $('.reg_uid-' + ind_uid).val(),
		ind_uid: $('.ind_uid-' + ind_uid).val(),
	};
	//if(task_uid !== false){
		data['_method'] = 'put';
	//}
	doneFunction = function(data, status, xhr){
		if(data.new_id){
			$('.task_uid-' + data.row_id).val(data.new_id);
		}
		if($('#ind_row_'+ind_uid+' .assign_user').hasClass('reassignSelect')){
			$('#ind_row_'+ind_uid+' .assign_user').removeClass('reassignSelect');
		}
	};

	console.log('assignUser, task_uid: ,'+task_uid);

	apiAjaxCall('tasks/setMember'+(task_uid !== false ? '/'+task_uid : '')+(view != false ? '?view=' + view : ''), 'POST', data, {}, {401: 'edit the dashboard.', 403: 'Please contact your Committee Chairperson or Administrator to make changes to dashboard.'}, doneFunction);
}

function setIndicatorSchedule(){
	if(!isMyView()){
		$('#dashboard_assign_tools').css('display', 'none');
		return false;
	}
	var months = [],
	    alert_months = [],
	    i = 0,
	    j = 0,
	    ind_uid = $(this).attr('rel'),
	    thisChildTD = $(this).children('tbody').children('tr').children('td'),
	    thisMonth = $(this).children('tbody').children('tr').children('td').attr('rel'),
	    totalForCurMonth = 0;

	if($(thisChildTD).hasClass('auto-styleAlert')) return;

	//  update class on button that was clicked
	if($(thisChildTD).hasClass('auto-style552'))
	{
	    $(thisChildTD).addClass('auto-style517').removeClass('auto-style552');
	}
	else if($(thisChildTD).hasClass('auto-style517'))
	{
		$(thisChildTD).addClass('auto-style552').removeClass('auto-style517');
	}

	// count total for the current month (scans verticaly)
	$('.indMonthTable').children('tbody').children('tr').children('td[rel="' + thisMonth + '"]').each(function(){
		if($(this).hasClass('auto-style552') || $(this).hasClass('auto-styleAlert')) totalForCurMonth++;
	});

	// count months selected for this indicataor (scans horizontaly)
	$('.indMonthTable[rel="' + ind_uid + '"] td').each(function() {
	    if ($(this).hasClass('auto-style552')) {
	        months[i] = $(this).attr('rel');
	        i++;
	    }
	    if ($(this).hasClass('auto-styleAlert')) {
	        alert_months[j] = $(this).attr('rel');
	        j++;
	    }
	});

	if(siteAdmin && false == true){
		apiAjaxCall('indicators/'+$('.ind_uid-'+ind_uid).val(), 'POST', {_method: 'put', 'months': months}, null, {401: 'modify the dashboard.', 301: 'Please contact your Committee Chairperson or Administrator to make changes to the Dashboard'});
	}else{
		if(!canEdit()){
			return false;
		}
		var task_uid = $('.task_uid-' + ind_uid).val();
		if(task_uid == '' && !demo) {
			popUpLoad('Updating Indicator Assignments...');
		}
		var data = {
			months: months,
			alert_months: alert_months,
			dep: dep,
			reg_uid: $('.reg_uid-'+ind_uid).val(),
			user: $('.task_asned_usr_uid-'+ind_uid).val(),
			uid: task_uid,
			ind_uid: $('.ind_uid-'+ind_uid).val(),
			cus_facility: $('#ind_row_' +ind_uid).attr('data-custom'),
			is_daily: is_daily,
			view: view
		};
		if(task_uid != ''){
			data['_method'] = 'put';
		}
		doneFunction = function(data, status, xhr){
			if(data.new_id){
				$('.task_uid-' + data.row_id).val(data.new_id);
			}
			setTimeout(removePopUpAndOverlay,1500);
		};
		apiAjaxCall('tasks'+(task_uid != '' ? '/'+task_uid : ''), 'POST', data, {}, {401: 'modify the dashboard.', 301: 'Please contact your Committee Chairperson or Administrator to make changes to the Dashboard', 302: {callback: function(){
			removePopUpAndOverlay();
		}}}, doneFunction);
	}
}

function setAlert(ind_uid, selectVal){
	if(!canEdit()){
		return false;
	}
	data = {
		dep: dep,
		task_reg_uid:$('.reg_uid-'+ind_uid).val(),
		task_uid:$('.task_uid-'+ind_uid).val(),
		task_ind_uid:$('.ind_uid-'+ind_uid).val(),
		task_alert:selectVal,
	};
	doneFunction = function(data, status, xhr){
		if(data.new_id){
			$('.task_uid-' + data.row_id).val(data.new_id);
		}
	};
	apiAjaxCall('tasks/alert', 'POST', data, {}, {401: 'edit the dashboard.', 403: 'Please contact your Committee Chairperson or Administrator to make changes to Dashboard.'}, doneFunction);
}

$(document).ready(function(){
	//if(search != ''){
		//searchAndHighlight(search);
	//}
	var isiPad = navigator.userAgent.match(/iPad/i) != null,
	    isiPhone = navigator.userAgent.match(/iPhone/i) != null;

	if(isiPad || isiPhone) $('#searchFormWrap').css('width', '470px');

	$('.assign_user, .sm_toggle').focus(function() { $('#dashboard_assign_tools').css('display', 'none'); });

	$('.pop_up, .overlay, #video').remove();

	$('.dash_cell_header #toggle_dropdown').click(function() {
		$('#dashboard_assign_tools').toggle();
		$('#configure_dashboard_wrapper ul').css('display', 'none');
	});
	$(function () {
		$.scrollUp({
			scrollName: 'scrollUp',      // Element ID
	        scrollDistance: 300,         // Distance from top/bottom before showing element (px)
	        scrollFrom: 'top',           // 'top' or 'bottom'
	        scrollSpeed: 300,            // Speed back to top (ms)
	        easingType: 'linear',        // Scroll to top easing (see http://easings.net/)
	        animation: 'fade',           // Fade, slide, none
	        animationSpeed: 200,         // Animation speed (ms)
	        scrollTrigger: false,        // Set a custom triggering element. Can be an HTML string or jQuery object
	        scrollTarget: false,         // Set a custom target element for scrolling to. Can be element or number
	        scrollText: 'Scroll to top', // Text for element, can contain HTML
	        scrollTitle: false,          // Set a custom <a> title if required.
	        scrollImg: true,             // Set true to use image
	        activeOverlay: false,        // Set CSS color to display scrollUp active point, e.g '#00FFFF'
	        zIndex: 2147483647
		});
	});

	$("#table_header").sticky({ topSpacing: 0, zIndex: 999999999});

	indicatorPopUpsHover();

	$('#search').submit(function(e){
		e.preventDefault();
		var viewParam = (view == 'ss') ? '&view=ss' : '';
		if(is_daily){
			window.location = '/facility/dashboard/daily/' + dep + '?search-term=' + encodeURI($('#search-term').val()) + viewParam;
		}else{
			window.location = '/facility/dashboard/' + dep + '?search-term=' + encodeURI($('#search-term').val()) + viewParam;
		}
		return false;
	});

	if(navigator.appVersion.indexOf("MSIE 10") != -1) {
		$('.cusIndBtns').css('height', '22px').css('padding-top', '6px');
	}

	setupSurveyToggle();

	// Current Clear/Assign Status
	var assign_toggle_status = 1;

	// FLASH EMAIL FEATURE HERE
	// $('#flash_email').css('cursor', 'pointer').click(function(){
	// 	$('#dashboard_assign_tools').toggle();

	// 	if(!isMyView()){
	// 		return false;
	// 	}else if(demo){
	// 		return false;
	// 	}

	// 	$('.assign_user option[value=""], .sm_toggle option[value=""]').each(function(){
	// 		$(this).attr('selected', 'selected');
	// 	});

	// 	assign_toggle_status = 2;
	// });

	// CLEAR FEATURE HERE
	$('#clear_indicators').css('cursor', 'pointer').click(function(){
		$('#dashboard_assign_tools').toggle();

		if(!isMyView()){
			return false;
		}else if(!canEdit()){
			return false;
		}
		if(demo){
			$('.assign_user option[value=""], .sm_toggle option[value=""]').each(function(){
				$(this).attr('selected', 'selected');
			});
		}else{
			$.post('/facility/dashboard/clear', {dep: dep, view: view}, function(data, status, xhr){
				if(status == 'success'){
					$('.assign_user option[value=""], .sm_toggle option[value=""]').each(function(){
						$(this).attr('selected', 'selected');
					});
				}else if(status == 'Unauthorized' || xhr.status == 401){
					demo = true;
					$('.assign_user option[value=""], .sm_toggle option[value=""]').each(function(){
						$(this).attr('selected', 'selected');
					});
				}else if(status == 'Forbidden' || xhr.status == 403){
					popUpMsg('Please contact your Committee Chairperson or Administrator to make changes to Dashboard.');
				}else{
					unknownError();
				}
			});
		}
	});

	$('#emailThirdLevel, #emailComCMS2567, #flash_email').click(function(e){

		e.preventDefault();

		if(!isMyView()){
			return false;
		}else if(!canEdit()){
			return false;
		}

		if(!demo){
			var data;
			if(assign_toggle_status == 2){
				var usr_ids = [];

				$('.assign_user').each(function(){
					cur_selected_usr = $(this).val();
					if(usr_ids.indexOf(cur_selected_usr) == -1 && cur_selected_usr != '') usr_ids.push(cur_selected_usr);
				});

				data = {
					dep: dep,
					usr_uids: usr_ids
				};
			}else{
				data = {dep: dep, view: view};
			}
			var doneFunction = function(data, status, xhr){
				if(data == 'success'){
					popUpMsg('Assigned Indicators have been emailed to Committee Members.', function(){
						if(assign_toggle_status == 2){
							window.location.reload();
						}
					});
				}
			};
			apiAjaxCall('tasks/emailTasks', 'POST', data, {}, {401: 'edit the dashboard.', 403: 'Please contact your Committee Chairperson or Administrator email assignments.'}, doneFunction);
		}
		return false;
	});

	//TUTORIAL CODE

	if($.cookie('has_tutorials') != 0 && $.cookie('has_tutorials_dashboard') != 0) {

	// get height of current category to set
	// bubbles in proper location on bottom of page

		var totalHeight = $('#master_wrapper').height();
		var masterOffsetTop = $('#master_wrapper').offset().top;
		var masterOffsetLeft = $('#master_wrapper').offset().left;

		var alertY = $('.auto-styleAlert').offset() ? $('.auto-styleAlert').offset().top - masterOffsetTop - 212: '137';
		var alertX = $('.auto-styleAlert').offset() ? $('.auto-styleAlert').offset().left - masterOffsetLeft + 14: '729';

		var userDim= $('.assign_user').filter(function() { return this.value != ""; }).first().offset();
		var userY  = userDim ? userDim.top - 195 : '208';


		var surveyY = $('.surveyMonth').offset() ? $('.surveyMonth').offset().top - masterOffsetTop - 210: '78';
		var surveyX = $('.surveyMonth').offset() ? $('.surveyMonth').offset().left - masterOffsetLeft + 14: '808';


		var b10 = totalHeight - 560,
			b11 = totalHeight - 570,
			b12 = totalHeight - 479;


		$("#content_wrapper").tutorials({
			locations: [
							['138', '445', 'Your DASHBOARD<br />comes pre-formatted and<br /> ready to go. Indicator\'s can be<br /> assigned DAILY, WEEKLY, MONTHLY, or ANNUALLY.<br /><a>CLICK HERE</a>'],
							['135', '554', 'If you received<br />multiple deficiencies<br />on your LAST SURVEY,<br />COMPLAINT VISIT or<br />MOCK SURVEY ...'],
							[alertY, alertX, "You can customize your<br />DASHBOARD to monitor<br />problem Indicators<br />more often."],
							[surveyY, surveyX, "Click the month of last years<br/>Annual Survey to view a RED border reminder."],
							[userY, '873', "Assign INDICATORS to<br />committee members using<br />the drop-down menu."],
							['87', '16', "RC - Resident Choice<br />QL - Quality of Life<br />CC - Clinical Care<br />MP - Mgnt Practices<br />FS - Facility Standards<br />SV - Surveys<br />AD - Audits"],
							['263', '175', "Each INDICATOR is written<br />to determine compliance with a specific Ftag, REGULATION, SURVEY or AUDIT question."],
							['306', '250', "Hold your mouse over<br />any INDICATOR to preview<br />before assigning to a<br />Committee Member."],
							//['279', '814', "The RED box shows a deficient practice has been found and the INDICATOR has been re-assigned each month until found to be in substantial compliance."],
							//[b10, '200', "Type any keyword and click GO to SEARCH INDICATORS on this page."],
							//[b11, '700', "Create your own<br />INDICATOR by clicking<br />ADD NEW INDICATOR."],
							[b12, '990', "Assigned INDICATORS are<br />automatically emailed<br />to Committee Members<br />on the first of each month<br />or EMAIL now."]
						],
			zIndex: 9999999,
			onFinish: function(){
							$.cookie('has_tutorials_dashboard', 0, { expires: 730, path: '/' });
							if(demo)
							{
								window.location.href = '/register';
							}
						}
		});

	}

	if(demo){
		$('.sm_toggle').change(function(){
			assignUser($(this).attr('rel'), $(this).val());
		});
	}

	$('#configure_dashboard_button').click(toggle_config_db_menu);

	$('.indMonthTable').click(setIndicatorSchedule);

	$('.auto-style552, .auto-style517').css('cursor','pointer');

	function toggle_config_db_menu() {
		$('#dashboard_assign_tools').css('display', 'none');
		$('#configure_dashboard_wrapper ul').toggle();
	}

	$('#configure_dashboard_wrapper ul li').click(function() {
		toggle_config_db_menu();
		var action = $(this).attr('data-action');
		var viewParam = (view == 'ss') ? '?view=ss' : '';

		if(action == 'daily' || action == 'weekly'){
			popUpConfMsg('Are you sure you want to set your dashboard to '+action.toUpperCase()+'?', function(){
				window.location = SITE_URL + 'facility/dashboard/daily/' + dep + viewParam;
			});
		}else{
			if(!isMyView()){
				return false;
			}else if(!canEdit()){
				return false;
			}
			if(action == 'return'){
				window.location = SITE_URL + 'facility/dashboard/' + dep + viewParam;
				return true;
			}
			if(action == 'monthly' || action == 'yearly' || action == 'biannually' || action == 'triannually' || action == 'quarterly'){
				if(action == 'yearly') var msg = 'Are you sure you want to set your dashboard to ANNUALLY?';
				else var msg = 'Are you sure you want to set your dashboard to ' + action.toUpperCase() + '?';
			}else{
				var msg = 'Are you sure you want to ' + action.toUpperCase() + ' your dashboard?';
			}
			popUpConfMsg(msg, function(){
				set_db_reset.call(this, action);
			});
		}
	});

	//DELETE INDICATOR
	$('.deleteIndicator').click(function(e){
		e.preventDefault();
		if(!canEdit()){
			return false;
		}
	    var ind_uid = $(this).attr('rel');
	    var yesAction = function(){
	    	var doneFunction = function(data, status, xhr){
    	    	window.location.href = window.location.href;
    	    	window.location.reload();
    	    };
    	    $.post('/indicators/delete-custom-indicator', {id : ind_uid}, function(data){
    	    	if(data.status == 'SUCCESS'){
    	    		doneFunction();
    	    	}else{
    	    		popUpMsg('Unable to delete indicator');
    	    	}
    	    });
	    };
	    popUpConfMsg("Are you sure you want to delete this indicator?", yesAction);
	    return false;
	});

	if(dep === 7)
		var taskHistoryHTML = '<div class="task-history-popup"><div class="history-content"> <span class="arrow-down"></span><table><thead><tr><th width="25%">Date</th><th width="60%">Member</th><th width="15%">AVG</th></tr></thead><tbody></tbody></table></div></div>';
	else
		var taskHistoryHTML = '<div class="task-history-popup"><div class="history-content"> <span class="arrow-down"></span><table><thead><tr><th width="25%">Date</th><th width="45%">Member</th><th width="15%">S&amp;S</th><th width="15%">%</th></tr></thead><tbody></tbody></table></div></div>';
	var $pop;
	$('.task_popup').hover(
	function(e)
	{
		$this = $(this);
		var task_uid = parseInt($this.find('a').attr('rel')),
			tds = popups[task_uid];
		$pop = $(taskHistoryHTML);
		for(var month in tds)
		{
			tds[month].forEach(function(v){
				if(dep === 7)
					$pop.find('tbody').append('<tr><td><span><a href="/facility/indicators?td='+v.td_uid+'&back=true">'+v.day+'</a></span></td><td><span>'+v.user+'</span></td><td><span>'+v.letter+'</span></td></tr>');
				else if(dep === 8)
					$pop.find('tbody').append('<tr><td><span><a href="/facility/indicators?td='+v.td_uid+'&back=true">'+v.day+'</a></span></td><td><span>'+v.user+'</span></td><td><span>'+v.compliance+'</span></td><td><span>'+v.letter+'</span></td></tr>');
				else
					$pop.find('tbody').append('<tr><td><span><a href="/facility/indicators?td='+v.td_uid+'&back=true">'+v.day+'</a></span></td><td><span>'+v.user+'</span></td><td><span>'+v.letter+'</span></td><td><span>'+v.compliance+'</span></td></tr>');
			});
		}
		$this.append($pop);
	},
	function(e)
	{
		$pop.remove();
	});

});
